import React, { useState } from 'react'
import blankProfile from '../../../assets/images/AboutUs/blank-profile.png'
import styles from './styles.module.css'
import { useTranslation } from 'react-i18next'
import { MdOutlineModeEdit } from 'react-icons/md'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { shallowEqual } from 'react-redux'
import { updateAboutMember } from '../../../entity/about-member/AboutMember'
import EditAboutMemberModal from '../../../components/EditAboutMemberModal/EditAboutMemberModal'
import { getUserData } from '../../../entity/user/model/selector/getUserData/getUserData'
import { getAboutSection } from '../../../entity/about-sections/AboutSection'
import DeleteMember from './DeleteMember/DeleteMember'

const MemberCard = ({ member }) => {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const user = useSelector(getUserData, shallowEqual)
  const [isOpen, setIsOpen] = useState(false)

  const modalHandler = () => {
    setIsOpen(prev => !prev)
  }

  const onEditAboutMemberSubmit = async values => {
    if (values && member?.id) {
      try {
        const formData = new FormData()
        formData.append('name_en', values.name_en)
        formData.append('name_ka', values.name_ka)
        formData.append('position_en', values.position_en)
        formData.append('position_ka', values.position_ka)
        formData.append('location_en', values.location_en)
        formData.append('location_ka', values.location_ka)
        formData.append('imageUrl', values.imageUrl)
        formData.append('sortOrder', values.sortOrder)

        await dispatch(updateAboutMember({ memberId: member.id, data: formData }))
        await dispatch(getAboutSection())
        modalHandler()
      } catch (error) {
        console.error('Error updating current issue:', error)
      }
    }
  }

  return (
    <div className={`${styles.member_card_container} group`}>
      {user?.role === 'admin' && (
        <>
          <MdOutlineModeEdit
            className='opacity-0 group-hover:opacity-100 my-2 text-4xl hover:scale-110 transition-all cursor-pointer text-[#326383] absolute top-0 left-2 border-2 border-[#326383] rounded-full p-1 bg-slate-100'
            onClick={modalHandler}
          />
          <DeleteMember memberId={member?.id} />
        </>
      )}

      {user?.role === 'admin' && (
        <div className='text-lg transition-all text-[#ffffff] absolute top-2 right-2 p-1 flex justify-center items-center bg-[#00000050] rounded-full px-2'>
          {member?.sortOrder}
        </div>
      )}
      <img
        src={member.imageUrl ? member.imageUrl : blankProfile}
        alt={i18n.language === 'ka' ? member.name_ka : member.name_en}
        className={`${styles.card_img} ${!member?.imageUrl && 'border'}`}
      />
      <div className={styles.member_description_wrapper}>
        {member?.name_en && (
          <p className={styles.member_name}>
            {i18n.language === 'ka' ? member?.name_ka : member?.name_en}
          </p>
        )}

        {member.position_en && (
          <p className={styles.member_position}>
            {i18n.language === 'ka' ? member.position_ka : member.position_en}
          </p>
        )}
        {member.location_en && (
          <p className={styles.member_location}>
            ({i18n.language === 'ka' ? member.location_ka : member.location_en})
          </p>
        )}
      </div>

      {isOpen && (
        <EditAboutMemberModal
          isOpen={isOpen}
          onClose={modalHandler}
          data={member}
          onSubmit={onEditAboutMemberSubmit}
        />
      )}
    </div>
  )
}

export default MemberCard
